// GENERATED by scripts/client/sync.ts — do not edit
export const CLIENT = {
	slug: 'biemme',
	displayName: 'Biemme Sistemi',
	productName: 'SLIMS PRO',
	locale: 'it-IT',
	timezone: 'Europe/Rome',
	appName: 'SLIMS PRO',
	logo: {
		src: '/brand/logo-pro.png',
		srcDark: undefined,
		mode: 'mask',
	},
	defaultMode: 'fleet',
} as const;
